import { DesktopWindow } from "../../desktopWindow/components/DesktopWindow";
import { useWindowTile } from "../../desktopWindow/context/WindowTilesContext";
import FileViewer from "./FileViewer";

interface Props {
	// Window tile id
	tileId: string;
}
export const FileViewerWindow = ({ tileId }: Props) => {
	const { componentName, componentProps, size } = useWindowTile(tileId);
	return (
		<DesktopWindow id={tileId}>
			<FileViewer file={componentProps!.file} size={size} name={componentName} />
		</DesktopWindow>
	);
};
